import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { CertificateRegistry } from "../../../Component/Model/Dto/CertificateRegistry/CertificateRegistry";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { DateFormatter } from "../../../Component/Model/helpers";

interface CertificateRegistryTableRow {
    CertificateNumber: string;
    ScorecardName: string;
    RegisteredEntityName: string;
    MeasurementPeriodStartDate: string;
    MeasurementPeriodEndDate: string;
    IssueDate: string;
    ExpiryDate: string;
    ScorecardType: string;
    ComplianceLevel: string;
    Actions?: ActionType[];
    CompanyName: string;
}


export interface ICertificateRegistryTable {
    columns: Array<TableColumn>;
    rows: Array<CertificateRegistryTableRow>;
}

function getActionColumns(item: CertificateRegistry.CertificateRegistrySearchResult, onViewCertificate: (documentId: number) => void, onEdit: (certificateId: number) => void, onDelete: (certificateId: number) => void): ActionType[] {
    const actions: ActionType[] = [];
    actions.push(
        {
            key: item.id.toString(),
            label: !item.scorecardId ? 'View/Edit' : 'View',
            action: () => {
                onEdit(item.id);
            },
            icon: {
                color: 'info',
                name: 'grading'
            }
        }
    );
    if (!item.scorecardId) {
        actions.push(
            {
                key: item.id.toString(),
                label: 'Delete',
                action: () => {
                    onDelete(item.id);
                },
                icon: {
                    color: 'error',
                    name: 'delete'
                }
            }
        );
    }
    if (item.portalDocumentId) {
        actions.push(
            {
                key: item.id.toString(),
                label: 'Download Certificate',
                action: () => {
                    onViewCertificate(item.portalDocumentId!);
                },
                icon: {
                    color: 'info',
                    name: 'download'
                }
            }
        );
    }
    return actions;
}

export function CertificateRegistryTableMapper(results: CertificateRegistry.CertificateRegistrySearchResult[], onViewCertificate: (documentId: number) => void, onEdit: (certificateId: number) => void, onDelete: (certificateId: number) => void): ICertificateRegistryTable {
    const columns = [
        { Header: 'Certificate Number', accessor: 'CertificateNumber', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" /> },
        { Header: 'Version Number', accessor: 'VersionNumber', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" /> },
        { Header: 'Scorecard Name', accessor: 'ScorecardName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" /> },
        { Header: 'Company Name', accessor: 'CompanyName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" /> },
        { Header: 'Applicable B-BBEE Codes', accessor: 'ScorecardType', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" />, disableSortBy: true },
        { Header: 'Measurement Start Date', accessor: 'MeasurementPeriodStartDate', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="45px" /> },
        { Header: 'Measurement End Date', accessor: 'MeasurementPeriodEndDate', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="45px" /> },
        { Header: 'Issue Date', accessor: 'IssueDate', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="45px" /> },
        { Header: 'Expiry Date', accessor: 'ExpiryDate', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="45px" /> },
        { Header: 'Recognised Level', accessor: 'ComplianceLevel', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];


    if (results.length >= 0) {
        const rows: CertificateRegistryTableRow[] = results.map((item: CertificateRegistry.CertificateRegistrySearchResult, index: number) => (
            {
                CertificateNumber: item.certificateNumber,
                VersionNumber: item.versionNumber,
                ScorecardName: item.scorecardName ?? "",
                RegisteredEntityName: item.registeredEntityName ?? "",
                CompanyName: item.companyName,
                ScorecardType: item.scorecardType,
                MeasurementPeriodStartDate: DateFormatter(item.measurementPeriodStartDate.toString()),
                MeasurementPeriodEndDate: DateFormatter(item.measurementPeriodEndDate.toString()),
                IssueDate: DateFormatter(item.issueDate.toString()),
                ExpiryDate: DateFormatter(item.measurementPeriodEndDate.toString()),
                ComplianceLevel: item.complianceLevel,
                Actions: getActionColumns(item, onViewCertificate, onEdit, onDelete)
            }));

        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}